var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stick-pop',_vm._b({on:{"click":_vm.show}},'stick-pop',_vm.$attrs,false),[_c('i',{staticClass:"el-icon-collection-tag",staticStyle:{"font-weight":"600"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-505e9410","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/stickpops/Follows.vue
// module id = null
// module chunks = 